export default {
  "filters": {
    "by_quarter": "Чорак кесимида",
    "growing": "Ўсиб борувчи",
    "all_regions": "Барча ҳудудлар",
    "all_cities": "Барча шаҳарлар",
    "by_region": "Худудлар кесимида/ Республика кесимида",
    "by_regions": "Худудлар кесимида",
    "by_employees": "Ходимлар бўйича",
    "search": "Қидириш",
    "by_region_count": "Худуд кесимида сони",
    "by_founders": "Таъсисчилар кесимида",
    "by_activity": "Фаолият тури кесимида",
    "by_status": "Статусни танланг",
    "sum": "Сўм бўйича",
    "number": "Сон бўйича",
  },
  'st_active': 'Амалда',
  'st_new': 'Янги',
  'st_removed': 'Чиқарилган',
  "year_2017": "2017",
  "year_2018": "2018",
  "year_2019": "2019",
  "year_2020": "2020",
  "year_2025": "2025",
  "year_2026": "2026",
  "header": {
    "title": "IT-Park резидентларининг иқтисодий кўрсаткичлари бўйича Ягона платформаси",
    "search": "Қидириш ..."
  },
  "permission": {
    "message": "Sizda ushbu dashbordga kirish imkoningiz cheklangan!",
    "login": "Login sahifasiga o'tish"
  },
  "periods": {
    "all": "Давр (бутун давр)",
    "all2": "бутун давр",
    "q1": "1 Чорак",
    "q2": "2 Чорак",
    "q3": "3 Чорак",
    "q4": "4 Чорак",
    "half": "Биринчи ярим йиллик",
    "half2": "Иккинчи ярим йиллик",
    "half2-5": "9 ойлик",
  },
  "dashboard": {
    "number_of_residents": "Резидент сони",
    "percent": "фоиз",
    "number_of_employees": "Ходимлар сони",
    "total_income": "Жами даромади",
    "total_income_mlrd": "Жами даромади (млрд.сум)",
    "export_volume_usd": "Экспорт ҳажми",
    "export_volume_usd_mlrd": "Эскпорт ҳажми (млн. АКШ доллар)",
    "general_indicators": "Умумий кўрсаткичлар",
    "report_indicators": "Ҳисобот кўрсаткичлари",
    "analytical_indicators": "Таҳлилий кўрсаткичлар",
    "audit_report_submission": "Аудиторлик ҳисобот топширилиши",
    "audit_not_submitted": "Аудиторлик ҳисоботини топширмаганлар",
    "tab_basic": "Умумий кўрсаткичлар",
    "tab_report": "Ҳисобот кўрсаткичлари",
    "tab_analytics": "Таҳлилий кўрсаткичлар",
    "in_detail": "батафсил",
    "collections": "Жамланма",
    "quarterly_report_submission": "Чораклик хисобот топширилиши",
    "deduction_payment_info": "Ажратма",
    "active_but_no_report": "Амалда резидент бўлиб ҳисобот тақдим қилмаганлар",
    "those_who_were_deprived_of_residency_during_this_period": "Ушбу даврда резидент бўлганлар",
    "number_of_deregistered_residents": "Ушбу даврда резидентликдан махрум булганлар",
    "deduction_payment_info_description": "Ажратма тўлови бўйича маълумот",
    "must_submit_resident": "Хисобот тақдим этиши лозим бўлган резидентлар",
    "given": "Тақдим этганлар",
    "un_given": "Тақдим этганлар",
    "returned_for_revision": "Тахрирлашга қайтарилганлар",
    "submitted": "Топширган",
    "debt_count": "Қарздорлик Сони",
    "not_submitted": "Топширилмаган",
    "more_details": "батафсил",
    "virtual_office": "Виртуал офис",
    "large_companies": "Йирик корхоналар",
    "count_companies": "Корхона сони",
    "download_general_info": "Умумий кўрсаткич бўйича барча маълумотларни Экселга юклаб олинг",
    "virtual_office_contracts": "Виртуал офис шартномаси тузилган резидентлар",
    "large_turnover_info": "Йирик айланмага эга резидентлар тўғрисидаги маълумот",
    "active": "Амалда",
    "revoked": "Чиқарилган",
    "main_comparison": "Таққослама",
    "export_comparison": "Таққослама",
    "by_countries": "Давлатлар кесимида",
    "main_indicator_comparison": "Асосий кўрсаткичларни мос даврга солиштириш",
    "export_vs_residence": "Экспорт хажмини резидент булган даврга нисбати",
    "export_share_by_countries": "Давлатлар кесимидаги экспорт улуши",
    "it_visa": "IT VISA",
    "export": "Экспорт",
    "foreign_capital_residents": "Хориж капитали иштирокидаги резидентлар",
    "foreign_capital_residents_organizations": "Хориж капитали иштирокидаги резидентлар",
    "it_visa_info": "IT VISA бўйича маълумот",
    "export_by_activity": "Фаолият турлари кесимидаги экспорт хажми",
    "foreign_organizations": "Хорижий Ташкилотлар",
    "download_report_info": "Ҳисобот кўрсаткичлари бўйича барча маълумотларни Excelga юклаб олинг",
    "it_park_rights": "IT Park Uzbekistan. All rights reserved",
    "residents_list": "Резидент рўйхати",
    "active_residents_count": "Амалдаги резидетлар сони",
    "is_active_residents_count": "Рўйхатдан чиқарилган резидентлар сони",
    "employee_count": "Ходим сони",
    "exporters": "Экпортчилар",
    "resident_info": "Резидентлар тўғрисидаги маълумот",
    "employee_info": "Ходимлар сони тўғрисида",
    "service_exporters_info": "Экспорт хизматларни амалга оширувчилар тўғрисида маълумот",
    "wage_amount": "Иш ҳақи суммаси",
    "total_count": "Сони",
    "total_countries": "Давлатлар сони"
  },
  "navigation": {
    "home": "Бош саҳифа",
    "reminders": "Эслатмалар",
    "reports": "Ҳисоботлар",
    "graphical_view": "График кўринишида",
    "general": "Умумий кўрсаткичлар",
    "residents": "Резидент рўйхати",
    "employees": "Ходимлар",
    "exporters": "Экспортчилар",
    "income": "Даромад",
    "table_view": "Жадвал кўринишида",
    "extended_info": "Кенгайтирилган маълумот",
    by_countries: "Давлатлар бўйича иқтисодий маълумот",
    "administrator": "Администратор",
    "tashkent_region": "Тошкент вилояти рўйхати",
  },
  "finance": {
    "total_income": "Жами даромад",
    "search": "Қидириш",
    "by_activity": "Фаолият тури кесимида",
    "by_region_amount": "Худуд кесимида суммаси",
    "by_activity_types": "Фаолият турлари кесимида",
    "active_13_5_trillion": "Амалда 13,5 трл.сўм",
    "total_amount": "Жами даромади ҳажми",
    "above_100b_soum": "Жами даромади ҳажми 100 млрд сўмдан юқори",
    "between_50b_100b_soum": "Жами даромади ҳажми 50 млрд сўмдан 100 млрд сўмгача",
    "between_1b_50b_soum": "Жами даромади ҳажми 1 млрд сўмдан 50 млрд сўмгача",
    "below_1b_soum": "Жами даромади ҳажми 1 млрд сўмгача"
  },
  "filters_periods": {
    "select_period": "Солиштириладиган даврни танланг:",
    "yearly_quarterly": "Йиллик (чорак)",
    "all": "Барчаси",
    "partial": "Қисман",
    "income": "Даромад",
    "employee_count": "Ходим сони",
    "export_amount": "Экспорт суммаси",
    "resident_count": "Резидент сони"
  },
  "advanced_filters": {
    "select_period": "Солиштириладиган даврни танланг:",
    "yearly_quarterly": "Йиллик (чорак)",
    "all": "Барчаси",
    "partial": "Қисман",
    "incomes": "Даромад",
    "employee_count": "Ходим сони",
    "export_amount": "Экспорт суммаси",
    "residents_count": "Резидент сони",
    "employees_salary": "Иш хақи суммаси",
    "incomes_10": "Айланмаси 10 млрддан ошганлар",
    "export_50": "Экспорт 50% юқори сони",
    "foreign_founder_residents": "Чет эллик таъсисчиси бор резидентлар сони",
    "developers": "Дастурчилар сони",
    "incomes_100": "Айланмаси 100 млрддан ошганлар",
    "export_100": "Экспорт 100% сони",
    "new_residents": "Янги резидент сони",
    "foreign_employees": "Чет эллик ходимлар",
    "virtual_office_contracts": "Виртуал офис шартномасини имзолаганлар сони",
    "out_residents": "Рўйхатдан чиқарилган сони",
    "clear": "Тозалаш",
    "generate_data": "Маълумотларни шакллантириш",
    "employees": "Ходимлар",
  },
  "deduction": "Ажратма",
  "charged": "Хисобланган",
  "total_employees": "Сони: 7 000 та ходим, 10 та компания",
  "total_employee": "Жами ходим",
  "from_this": "шундан",
  "serial_number": "T/p",
  "organization_tin": "СТИР",
  "organization_name": "Ташкилот номи",
  "region": "Худуд",
  "city": "Шахар",
  "founder_country": "Таъсисчи давлат",
  "registration_date": "Рўйхатга олинган сана",
  "resident_status": "Резидент ҳолати",
  "organization_type": "Ташкилот тури",
  "export_share": "Экспорт улуши",

  "admin_staff": "Маъмурий ходимлар",
  "core_staff": "Асосий штат ходимлари",
  "developers": "Дастурчилар",
  "it_service_providers": "Ахборот хизматини кўрсатувчилар",
  "teachers": "Ўқитувчилар",
  "employee_count": "Ходим сони",
  "mhtf": "МХТФ",
  "period": "Давр",
  "chart_view": "График кўриниш",
  "table_view": "Жадвал",
  "export_direction": "Экспорт йўналиши",
  "export_by_services": "Экспорт хизматлар кесимида",
  "eu_uk": "EU and UK",
  "cis_apac": "CIS & APAC",
  "total_export": "Жами экспорт",
  "north_america": "NORTH AMERICA",
  "mena": "MENA",
  "founders_export_share": "Таъсисчилар экспорт улуши кесимида",
  "residents_period": "Резидентлар даври",
  "up_to_year": "йилгача",
  "year": "йил",
  "search": "Қидириш",
  "employees": "Ходимлар",
  "home": "Бош саҳифа",
  "reminders": "Эслатмалар",
  "new": "Янги",
  "bpo": "BPO",
  "issued": "Чиқарилган",
  "general": "Умумий",
  "residents": "Резидентлар",
  "year_2021": "2021",
  "year_2022": "2022",
  "year_2023": "2023",
  "year_2024": "2024",
  "exporters": "Экспортчилар",
  "export": "Экспорт",
  "total_income": "Жами даромад",
  "percentage_10": "10%",
  "percentage_30": "30%",
  "income_300m": "300 млн",
  "table_view_detailed": "Жадвал кўринишида",
  "detailed_info": "Кенгайтирилган маълумот",
  "admin": "Администратор",
  "currency_trillion_soum": "трлн.сўм.",
  "currency_million": "млн",
  "regions_view": "Худудлар кесимида/Республика кесимида",
  "residents_view": "Резидентлар бўйича",
  "region_based": "Худуд бўйича",
  "activity_based": "Фаолият бўйича",
  "founders_based": "Таъсисчилари бўйича",
  "it_park": "IT парк",
  "software_dev": "ДТни ишлаб чиқиш",
  "usa": "АҚШ",
  "russia": "Россия",
  "samarkand": "Самарқанд",
  "it_education": "IT таълим",
  "poland": "Полша",
  "top_5": "ТОП-5",
  "top_5_regions": "ТОП-5 худуд",
  "top_5_industry": "ТОП-5 Фаолият",
  "top_5_country": "ТOП-5 мамлакат",
  "toshkent_region": "Тошкент вилояти",
  "industry": "Фаолият",
  "vro": "ВРО",
  "country": "мамлакат",
  "germany": "Германия",
  "china": "Хитой",
  "reports": "Ҳисоботлар",
  "bukhara": "Бухоро",
  "support": "Қўллаб-қувватлаш",
  "graphical_view": "График кўринишида",
  "fergana": "Фарғона",
  "license_sales": "Лицензияларни сотиш",
  "top_5_growth": "ТОП-5 сони ўсганлар",
  "andijan": "Андижон",
  "tashkent": "Тошкент",
  "administrative_staff": "Маъмурий ходимлар",
  "living_status": "Яшовчанлиги бўйича",
  "registered": "Рўйхатга олинган",
  "revoked_residents": "Резидентликдан чиқарилган",
  "close": "ёпиш",
  "Работники, участвующие в основной (производственной)": "Aсосий (ишлаб чиқариш) фаолиятида иштирок етадиган ишчилар",
  "Сотрудники оказывающие информационные услуги": "Aхборот хизматларини кўрсатадиган ходимлар",

  "Вход в кабинет": "Kirish",
  "Пользователь не найден": "User not found",
  "Такого пользователя нет.": "There is no such user.",
  "Проверьте введенные данные и повторите попытку.": "Please check the entered data and try again.",
  "вернуться к входу": "back to login",
  "Единая система идентификации (OneID) предназначена для простого и безопасного доступа пользователей к различным информационным системам электронного правительства и государственных органов.": "OneID foydalanuvchining turli elektron hukumat va davlat axborot tizimlariga oson va xavfsiz kirishi uchun moʻljallangan.",

  "Единая платформа экономических показателей резидентов ИТ-парка": "IT-Park резидентларининг иқтисодий  кўрсаткичлари бўйича Ягона платформаси",
  "поиск": "Қидириш",
  "Мой счет": "Менинг аккаунтим",
  "1 год": "1 йил",

  "Иностранные граждане являются работающими резидентами": "Чет эллик фуқаролар ишловчи резидентлар",

  "Ежегодно": "Йиллик",
  "Ежеквартальный": "Чораклик",
  "Площадь (общая)": "Ҳудуд (жами)",
  "Общий": "Жами",

  "QR": "ҚҚР",
  "Андижанская область": "Андижон вилояти",
  "Республика Каракалпакстан\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t": "Қоракалпоғистон Республикаси\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
  "Бухарская область": "Бухоро вилояти",
  "Джизакская область": "Жиззах вилояти",
  "Кашкадарьинская область": "Қашқадарё вилояти",
  "Навоийская область": "Навоий вилояти",
  "Наманганская область": "Наманган вилояти",
  "Самаркандская область": "Самарқанд вилояти",
  "Сурхандарьинская область": "Сурхондарё вилояти",
  "Сырдарьинская область": "Сирдарё вилояти",
  "Ташкентская область": "Тошкент вилояти",
  "Ферганская область": "Фарғона вилояти",
  "Хорезмская область": "Хоразм вилояти",
  "город Ташкент": "Тошкент шаҳар",
  "млрд сум": "млрд cўм",
  "Количество жителей": "Резидент сони",
  "Общий доход\r\n(млрд сумов)": "Жами даромади \r\n(млрд.сўм)",
  "Прочие доходы": "Бошқа даромадлар",
  "Объем экспорта,\r\nмлн долл. США": "Экспорт ҳажми, \r\nмлн.АҚШ.долл",
  "Общие показатели": "Умумий кўрсаткичлар",
  "Аналитические индикаторы": "Таҳлилий кўрсаткичлар",
  "Список резидентов": "Резидент рўйхати",
  "Информация о резидентах": "Резидентлар тўғрисидаги маълумот",
  "Количество сотрудников": "Ходим сони",
  "О численности сотрудников": "Ходимлар сони тўғрисида",
  "Размер заработной платы": "Иш ҳақи суммаси",
  "Экспортеры": "Экпортчилар",
  "Информация о поставщиках экспортных услуг": "Экспорт хизматларни амалга оширувчилар тўғрисида маълумот",
  "Количество стран": "Давлатлар сони",
  "IT Park Uzbekistan. Все права защищены 2019-2024": "IT Park Uzbekistan. Hamma huquqlar himoyalangan 2019-2024",
  "Представление аудиторского отчета": "Аудиторлик ҳисобот топширилиши",
  "Те, кто не представил аудиторский отчет": "Аудиторлик ҳисоботини топширмаганлар",
  "Брошенный": "Топширган",
  "Не представлено": "Топширилмаган",
  "подробно": "батафсил",
  "Представление ежеквартального отчета": "Чораклик хисобот топширилиши",
  "На практике они не подавали отчеты как резиденты": "Амалда резидент бўлиб ҳисобот тақдим қилмаганлар",
  "Информация о плате за увольнение": "Ажратма тўлови бўйича маълумот",
  "Число": "Сони",
  "Информация о резидентах с высоким оборотом": "Йирик айланмага эга резидентлар тўғрисидаги маълумот",
  "Виртуальный офис": "Виртуал офис",
  "Резиденты с контрактом на виртуальный офис": "Виртуал офис шартномаси тузилган резидентлар",
  "На практике": "Амалда",
  "Выпущенный": "Чиқарилган",
  "Крупные предприятия": "Йирик корхоналар",
  "Информация о резидентах с высокой текучестью кадров": "Йирик айланмага эга резидентлар тўғрисидаги маълумот",
  "Выгрузить все данные по «Общему показателю» в Excel": "“Умумий кўрсаткич” бўйича барча маълумотларни Экселга юклаб олинг",
  "Показатели отчета": "Хисобот кўрсаткичлари",

  "Ежеквартальный отчет": "Чораклик хисобот",
  "Агрегация": "Жамланма",
  "На сегодняшний день статус": "Сана холатига",
  "Информация (по возрастанию)": "Маълумот (ўсиб борувчи)",
  "Имя за именем": "Номма-ном",
  "№": "Т/р",
  "Районы": "Ҳудудлар",
  "Сообщаемые жители": "Кўриб чиқиш жараёнида",
  "Ведущие": " Тақдим этганлар (қабул қилинган)",
  "Возвращено для редактирования": "Таҳрирлашга қайтарилганлар",
  "Те, кто не представил": "Тақдим этмаганлар",
  "В процессе приёма": "Қабул қилиш жараёнда",
  "Всего по регионам": "Ҳудудлар бўйича жами",
  "Скачать": "Юклаб олиш",
  "Выберите формат": "Форматни танланг",
  "Сохранять": "Сақлаш",
  "Аудиторский отчет": "Аудиторлик хулоса",
  "Сравнение": "Таққослама",
  "Сравнение основных показателей с соответствующим периодом": "Асосий кўрсаткичларни мос даврга солиштириш",
  "Соотношение объема экспорта к периоду проживания": "Экспорт хажмини резидент булган даврга нисбати",
  "В разрезе штатов": "Давлатлар кесимида",
  "Доля экспорта по странам": "Давлатлар кесимидаги экспорт улуши",
  "Виза для собак": "IT VISA",
  "Информация о IT VISA": "IT VISA бўйича маълумот",
  "Экспорт": "Экспорт",
  "Объем экспорта в разрезе видов деятельности": "Фаолият турлари кесимидаги экспорт хажми",
  "Резиденты с участием иностранного капитала": "Хориж капитали иштирокидаги резидентлар",
  "Иностранные организации": "Хорижий Ташкилотлар",
  "Загрузите всю информацию по «Показателям отчета» в Excel": "“Ҳисобот кўрсаткичлари” бўйича барча маълумотларни Excelga юклаб олинг",
  "ПОМЕШИВАТЬ": "СТИР",
  "Название организации": "Ташкилот номи",
  "Территория": "Худуд",
  "Разделение": "Ажратма",
  "Баланс": "Сальдо",
  "Рассчитано": "Хисобланган",
  "Оплаченный": "Тўланган",
  "Список Ташкентской области": "Тошкент вилояти рўйхати",
  "Название компании:": "Корхона номи:",
  "Период:": "Давр:",
  "Дата операции": "Операция санаси",
  "Содержание операции": "Операция мазмуни",
  "Дата платежа": "Тўлов санаси",
  "Оборот в отчете": "Хисоботдаги айланма",
  "Рассчитано на оплату": "Тўлаш учун ҳисобланган",
  "Задолженность": "Қарздорлик",
  "Переплата": "Ортиқча тўлов",
  "Город": "Шахар",
  "Дата регистрации": "Рўйхатга олинган сана",
  "Статус резидента": "Резидент ҳолати",
  "Резидент": "Резидент",
  "Тип организации": "Ташкилот тури",
  "Государство-основатель": "Таъсисчи давлат",
  "Количество используемых жилых помещений": "Амалдаги резидетлар  сони",
  "от этого": "шундан",
  "дата платежа": "тўлов санаси",
  "Добавлено в этот период": "Ушбу даврда қўшилганлар",
  "Количество снятых с регистрации жителей": "Рўйхатдан чиқарилган резидентлар сони",
  "Лица, лишенные права проживания в этот период": "Ушбу даврда резидентликдан маҳрум бўлганлар",
  "Номер компании": "Корхона сони",
  "Всего сотрудников": "Жами ходим",
  "Административный персонал": "Маъмурий ходимлар",
  "MXTF": "МХТФ",
  "Ключевой персонал": "Асосий штат ходимлари",
  "Программисты": "Дастурчилар",
  "Поставщики информационных услуг": "Ахборот хизматини кўрсатувчилар",
  "Учителя": "Ўқитувчилар",
  "Экспорт резидентов": "Экспортчи резидентлар",
  "Учредители — иностранные резиденты": "Таъсисчилари чет эллик резидент",
  "компания": "компания",
  "Название организации и ИНН": "Ташкилот номи ва СТИР",
  "Дата резидентства": "Резидентлик санаси",
  "Территория и город": "Худуд ва Шахар",
  "Страна регистрации и дата регистрации": "Таъсисчи давлат ва  Рўйхатга олинган сана",
  "Доля экспорта": "Экспорт улуши",
  "Направление экспорта": "Экспорт йўналиши",
  "Графический вид": "График кўриниш",
  "Стол": "Жадвал",
  "В секторе экспортных услуг": "Экспорт хизматлар кесимида",
  "Общий экспорт": "Жами экспорт",
  "ИТ-услуги": "IT хизматлар",
  "ИТ-образование": "IT таълим",
  "Игровая разработка и креатив": "Геймдев & Креатив",
  "Программные продукты": "Дастурий маҳсулотлар",
  "Основатели в разрезе доли экспорта": "Таъсисчилар экспорт улуши кесимида",
  "Период резидентства": "Резидентлар даври",
  "Доход": "Даромад",
  "Расширенная информация": "Кенгайтирилган маълумот",
  "Администратор": "Администратор",

  "Домашняя страница": "Бош саҳифа",
  "Примечания": "Эслатмалар",
  "Отчеты": "Ҳисоботлар",
  "В графическом виде": "График кўринишида",
  "В табличном виде": "Жадвал кўринишида",
  "В разделе территорий / в разделе Республики": "Худудлар кесимида / Республика кесимида",
  "Жители": "Резидентлар бўйича",
  "По территории": "Худуд бўйича",
  "По активности": "Фаолият бўйича",
  "По словам основателей": "Таъсисчилари бўйича",
  "Развитие ДТ": "ДТни ишлаб чиқиш",
  "Поддерживать": "Қўллаб-қувватлаш",
  "Продажа лицензий": "Лицензияларни сотиш",
  "По пригодности для жизни": "Яшовчанлиги бўйича",
  "Зарегистрировано": "Рўйхатга олинган",
  "Исключен из резиденции": "Резидентликдан чиқарилган",
  "Число в поперечном сечении территории": "Худуд кесимида сони",
  "В разделе учредителей": "Таъсисчилар кесимида",
  "В разделе «Тип деятельности»": "Фаолият тури кесимида",
  "По категориям сотрудников": "Ходимлар тоифаси бўйича",
  "В зависимости от размера заработной платы": "Иш ҳақи суммаси бўйича",
  "Об иностранных гражданах": "Чет эллик фуқаролар бўйича",
  "Основатель": "Таъсисчи",
  "Количество организаций с долей экспорта более 50 процентов": "Экспорт улуши 50 фоиздан юқори ташкилотлар сони",
  "По объему экспорта": "Даромад хажми кесимида",
  "Объем экспорта": "Экспорт хажми",
  "practice_text": "<p>Амалда {amount} млн.сум <br>  Сони {count} та</p>",
  "practice_text2": "<p>Амалда {amount} млн.долл. <br>  Сони {count} та</p>",
  "Доля суммы": "Суммадаги улуши",
  "Объем экспорта более 10 миллионов долларов": "Жами даромади ҳажми 100 млрд сўмдан юқори",
  "Объем экспорта более 10 миллионов долларов2": "Экспорт ҳажми 10 млн доллардан юқори",
  "Объем экспорта от 1 млн до 10 млн за доллар": "Жами даромади ҳажми 1 млрд сўмдан 50 млрд сўмгача",
  "Объем экспорта от 1 млн до 10 млн за доллар2": "Экспорт ҳажми 5 млндан 10 млн. долларгача",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар": "Жами даромади ҳажми 50 млрд сўмдан 100 млрд сўмгача",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар2": "Экспорт ҳажми 50 мингдан 5 млн. долларгача",
  "Объем экспорта до 100 тыс. долларов": "Жами даромади ҳажми 1 млрд сўмгача",
  "Объем экспорта до 100 тыс. долларов2": "Экспорт ҳажми 50 минг долларгача",
  "В разделе стран-экспортеров": "Экспорт қилинган мамлакатлар кесимида",
  "ТОП-5 стран": "ТОП-5 мамлакат",
  "Сумма территории": "Худуд кесимида суммаси",
  "Общий доход составляет более 100 млрд сумов.": "Жами даромади ҳажми 100 млрд сўмдан юқори",
  "Общий доход от 50 млрд сумов до 100 млрд сумов": "Жами даромади ҳажми 50 млрд сўмдан 100 млрд сўмгача",
  "Общий доход от 1 млрд сумов до 50 млрд сумов.": "Жами даромади ҳажми 1 млрд сўмдан 50 млрд сўмгача",
  "Общий доход до 1 млрд сумов": "Жами даромади ҳажми 1 млрд сўмгача",
  "Выберите период для сравнения:": "Солиштириладиган даврни танланг:",
  "Ежегодно (ежеквартально)": "Йиллик (чорак)",
  "В разделе территории": "Худуд кесимида",
  "Вид деятельности (все)": "Фаолият тури (барчаси)",
  "Территория (вся)": "Худуд (барчаси)",
  "Страна экспорта (все)": "Экспорт давлат (барчаси)",
  "Основатели": "Таъсисчилар",
  "Страны (все)": "Давлатлар (барчаси)",
  "Все": "Барчаси",
  "Частично": "Қисман",
  "Выберите соответствующий индикатор:": "Кераклик кўрсатгични танланг:",
  "Сумма экспорта": "Экспорт суммаси",
  "Те, чей оборот превышает 10 млрд.": "Айланмаси 10 млрддан ошганлар",
  "На 50% больше экспортных поставок": "Экспорт 50% юқори сони",
  "Количество резидентов с иностранным учредителем": "Чет эллик таъсисчиси бор резидентлар сони",
  "Количество программистов": "Дастурчилар сони",
  "Экспорт 100% числа": "Экспорт 100% сони",
  "Количество новых жителей": "Янги резидент сони",
  "Иностранные сотрудники": "Чет эллик ходимлар",
  "Количество подписавших соглашение о виртуальном офисе": "Виртуал офис шартномасини имзолаганлар сони",
  "Количество регистраций": "Рўйхатдан чиқарилган сони",
  "Очистить": "Тозалаш",
  "Формирование данных": "Маълумотларни шакллантириш",
  "квартал": "чорак",
  "Поиск": 'Қидирув',
  "География экспорта": "Eksport geografiyasi",
  "inp_fild": 'Қизиқтирган саволни ёзишингиз мумкун',

  "Выберите тип организации": "Ташкилот турини танланг",
  "Выберите страну": "Давлатни танланг",
  "Выберите день": 'Кунни танланг',
  "Распределение экспорта": "Экспорт тақсимоти",

  "все резиденты": "Барчаси",
  "Все резиденты": "Барча резидентлар",
  "Неэкспортеры": "Экспорт мавжуд эмас",

  "резиденты с иностранными учредителями": "Чет еллик таъсисчиси бор резидентлар",
  "резиденты без иностранных учредителей": "Чет еллик таъсисчиси йўқ резидентлар",

  "Название компании": "Ташкилот номи",
  "Учредитель": "Таъсисчи",
  "Вид деятельности": "Фаолият тури",
  "География Экспорта": "Экспорт географияси",
  "Кол-во сотрудников": "Ходимлар сони",

  "за весь год": "бутун йил учун",
  "за x-квартал": "{x}-чорак учун",
  // "": "",
  "by_income": "Даромад бўйича",
  "by_indicator": "Кўрсаткичлар бўйича",
  "residents_required_to_submit_reports": "Ҳисобот тақдим этиши лозим бўлган резидентлар",
  "submitted": "Тақдим этганлар",
  "returned_for_editing": "Таҳрирлашга қайтарилганлар",
  "not_submitted": "Тақдим этмаганлар",
  "totalDebtTitle": "Жами қарз",
  "totalDebtInfo": "резидент",
  "totalOverpaymentTitle": "Жами ортиқ тўлов",
  "totalOverpaymentInfo": "резидент",
  "accruedForThePeriodTitle": "Муддат учун тўланди",
  "accruedForThePeriodInfo": "резидент",
  "numberOfResidentsTitle": "Резидентлар сони",
  "numberOfResidentsInfo": "Фаол компаниялар",
  "footer_rights": "IT Парк Ўзбекистон. Барча ҳуқуқлар ҳимояланган 2019-2024",
  "1": "Январ",
  "2": "Феврал",
  "3": "Март",
  "4": "Апрел",
  "5": "Май",
  "6": "Июн",
  "7": "Июл",
  "8": "Август",
  "9": "Сентябр",
  "10": "Октябр",
  "11": "Ноябр",
  "12": "Декабр",
  "all": "Barchasi",
  "resident": "Резидент",
  "excluded": "Chiqarilgan",
  "select": "Танлаш",
  "search_inn": "ИНН бўйича қидириш",
  "export_table": "Кенгайтирилган-маълумот",
  "inn": "ИНН",
  "accrued": "Ҳисобланган",
  "show": "Кўрсатиш",
  "no_data_found": "Маʼлумот топилмади",
  "no_data": "Маʼлумот йўқ",
  "financial_summary_on": "Сана бўйича молиявий ҳисобот",
  "opening_balance": "Йил бошидаги сальдо",
  "accrued_for_period": "Давр учун ҳисобланган",
  "paid_for_period": "Давр учун тўланган",
  "total_debt": "Умумий қарз",
  "overpayment": "Ортиқча тўлов",
  "current_balance": "Бугунги сальдо",
  "report_date": "Ҳисобот санаси",
  "income": "Даромад",
  "payable": "Ажратма суммаси",
  "payment_date": "Тўлов санаси",
  "paid": "Тўланган",
  "balance": "Сальдо",
  "overdue": "Муддати ўтган",
  "status": "Ҳолат",
  "days": "кун",
  "Все статусы": "Барча ҳолатлар",
  "Оплачено": "Тўланган",
  "Задолженость": "Қарздорлик",
  "regions": "Ҳудуд",


  "quarter_report": "{quarter}-чорак учун ҳисобот",
  "день": "кун",
  "дня": "кун",
  "дней": "кун",
  "table_parameters": "Жадвални шакллантириш учун параметрларни кўрсатинг",
  "main": "Асосий",
  "activity_types": "Фаолият турлари",
  "export_countries1": "Экспорт давлатлари",
  "regions1": "Минтақалар",
  "countries": "Давлатлар",
  "collapse": "Йиғиш",
  "indicators": "Кўрсаткичлар",
  "reset_filters": "Фильтрларни тозалаш",
  "generate_table": "Жадвални шакллантириш",
  "result": "Ёйиш",
  "quantity": "Миқдори",
  "percent": "% да",
  "млрд. сум": "млрд. сўм",
  "млн. дол. США": "миллион АҚШ доллари",
  "residents_count": "Барча резидентлар",
  "export_amount": "Экспорт суммаси (АҚШ долл.)",
  "half_year": "Ярим йиллик",
  "yearly": "Йиллик",
  "nine_months": "Тўққиз ой",
  "Йиллик": "Йиллик",
  "Ярим йиллик": "Ярим йиллик",
  "1 квартал": "1 квартал",
  "2 квартал": "2 квартал",
  "3 квартал": "3 квартал",
  "4 квартал": "4 квартал",
  "foreign_capital": "Чет эл капитали иштирокидаги резидентлар",
  "exporting": "Экспорт қилувчи резидентлар",
  "company_name": "Корхона номи",
  "direction": "Йўналиш",
  "detailed_information": "Батафсил маълумот",
  "date_of_application_of_the_benefit": "Имтиёзни қўллаш санаси",
  "Страна-экспортер": "Экспорт қилинган давлат",
  "more_th_50_percent": "50% dan yuqori",
}




